import { call, put, takeLatest } from '@redux-saga/core/effects';
import Apis from '../../../../api';
import { CommonAction } from '../../../login/redux/types';
import { dealTypes } from '../../../login/utils/Status';
import MessageActions from '../../../message/redux/actions';
import { parseInvestments, parseReportingObligation } from '../utils';
import InvestmentsActions from './actions';
import InvestmentTypes from './types';

const fetchInvestmentsReq = function* fetchInvestmentsReq() {
    try {
        const { data } = yield call(Apis.getInvestments);
        const investments = parseInvestments(data || []);
        yield put(InvestmentsActions.setInvestments(investments || []));
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(InvestmentsActions.setInvestments([]));
    }
};

const fetchRepaymentReq = function* fetchRepaymentReq(action: CommonAction) {
    try {
        const investmentUUID = action.payload;
        const { data } = yield call(Apis.fetchRepayment, investmentUUID);
        // data.executedAgreements = [];
        // data.updates = [];
        // if (data && data.deal) {
        //     try {
        //         const executedAgreementsRes: { data: DataRoom[] } = yield call(
        //             Apis.getExecutedAgreements,
        //             data.deal.uuid,
        //         );

        //         data.executedAgreements = (executedAgreementsRes && executedAgreementsRes.data) || [];
        //         const updatesRes: { data: DataRoom[] } = yield call(Apis.getUpdates, data.deal.uuid);
        //         data.updates = (updatesRes && updatesRes.data) || [];
        //     } catch (err) {}
        // }
        // let doc: DataRoom[] = [];
        // data.investment &&
        //     data.investment.documents &&
        //     data.investment.documents.forEach((d: any) => {
        //         doc.push({
        //             name: d.title,
        //             type: 'File',
        //             investmentUUID: data.investment.uuid,
        //             dealUUID: data.deal.uuid,
        //             group: 'ExecutedAgreements',
        //             isDownloadable: false,
        //             uuid: '',
        //         });
        //     });
        // data.executedAgreements = doc.concat(data.executedAgreements || []) || [];
        yield put(InvestmentsActions.setRepayment(data));
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(InvestmentsActions.setRepayment([]));
    }
};

const fetchInvestmentDetailsReq = function* fetchInvestmentDetailsReq(action: CommonAction) {
    try {
        const uuid = action.payload;
        const { data } = yield call(Apis.getInvestmentDetails, uuid);
        yield put(InvestmentsActions.setInvestmentDetails(data));
        if (data?.deal?.info.summary?.dealType === dealTypes.debt) {
            yield put(InvestmentsActions.fetchRepaymentReq(uuid));
        }
        if (data?.deal?.info.summary?.dealType === dealTypes.fund) {
            yield put(InvestmentsActions.fetchPerformances(uuid));
            yield put(InvestmentsActions.fetchDistributions(uuid));
        }
    } catch (err) {
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(InvestmentsActions.setInvestmentDetails(undefined));
    }
};

const fetchExecutedAgreementsReq = function* fetchExecutedAgreementsReq(action: CommonAction) {
    try {
        const dealUUID = action.payload;
        const { data } = yield call(Apis.getExecutedAgreements, dealUUID);
        yield put(InvestmentsActions.setExecutedAgreements(data));
    } catch (err) {
        //yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(InvestmentsActions.setExecutedAgreements(undefined));
    }
};

const fetchUpdatesReq = function* fetchUpdatesReq(action: CommonAction) {
    try {
        const dealUUID = action.payload;
        const { data } = yield call(Apis.getUpdates, dealUUID);
        yield put(InvestmentsActions.setUpdatesOrReporties(data));
    } catch (err) {
        //yield put(MessageActions.showMessage({ error: true, text: String(err) }));
        yield put(InvestmentsActions.setUpdatesOrReporties(undefined));
    }
};

const fetchPerformancesReq = function* fetchPerformancesReq(action: CommonAction) {
    try {
        const uuid = action.payload;
        const { data } = yield call(Apis.fetchPerformaces, uuid);
        yield put(InvestmentsActions.setPerformances(data));
    } catch (err) {
        yield put(InvestmentsActions.setPerformances(undefined));
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};

const fetchDistributionReq = function* fetchDistributionReq(action: CommonAction) {
    try {
        const investmentUUID = action.payload;
        const { data } = yield call(Apis.fetchDistributions, investmentUUID);
        yield put(InvestmentsActions.setDistributions(data));
    } catch (err) {
        yield put(InvestmentsActions.setDistributions(undefined));
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};

const fetchPPMReq = function* fetchPPMReq(action: CommonAction) {
    try {
        const { dealUUID, investorUUID } = action.payload;
        const { data } = yield call(Apis.fetchPPM, dealUUID, investorUUID);
        yield put(InvestmentsActions.setPPM(data));
    } catch (err) {
        yield put(InvestmentsActions.setPPM(undefined));
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};

const fetchReportingObligationReq = function* fetchReportingObligationReq(action: CommonAction) {
    try {
        const dealUUID = action.payload;
        const { data } = yield call(Apis.fetchReportingObligation, dealUUID);
        const reportingObligations = parseReportingObligation(data || []);
        yield put(InvestmentsActions.setReportingObligations(reportingObligations || []));
    } catch (err) {
        yield put(InvestmentsActions.setReportingObligations([]));
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};

const fetchCashflowReq = function* fetchCashflowReq(action: CommonAction) {
    try {
        const investmentUUID = action.payload;
        const { data } = yield call(Apis.fetchCashflow, investmentUUID);
        yield put(InvestmentsActions.setCashflow(data || []));
    } catch (err) {
        yield put(InvestmentsActions.setCashflow([]));
        yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};

const fetchGuaranteesReq = function* fetchGuaranteesReq(action: CommonAction) {
    try {
        const investmentUUID = action.payload;
        const { data } = yield call(Apis.fetchGuarantees, investmentUUID);
        yield put(InvestmentsActions.setGuarantees(data || []));
    } catch (err) {
        yield put(InvestmentsActions.setGuarantees([]));
        //yield put(MessageActions.showMessage({ error: true, text: String(err) }));
    }
};

const fetchSecuritiesReq = function* fetchSecuritiesReq(action: CommonAction) {
    try {
        const investmentUUID = action.payload;
        const { data } = yield call(Apis.fetchSecurities, investmentUUID);
        yield put(InvestmentsActions.setSecurities(data || []));
    } catch (err) {
        yield put(InvestmentsActions.setSecurities([]));
    }
};

const fetchCovenantsReq = function* fetchCovenantsReq(action: CommonAction) {
    try {
        const investmentUUID = action.payload;
        const { data } = yield call(Apis.fetchCovenants, investmentUUID);
        yield put(InvestmentsActions.setCovenants(data || []));
    } catch (err) {
        yield put(InvestmentsActions.setCovenants([]));
    }
};

const fetchAggregateReq = function* fetchAggregateReq() {
    try {
        const { data } = yield call(Apis.fetchAggregate);
        yield put(InvestmentsActions.setAggregate(data || undefined));
    } catch (err) {
        yield put(InvestmentsActions.setAggregate(undefined));
    }
};

const fetchUpdatedDcoumentsReq = function* fetchUpdatedDcoumentsReq() {
    try {
        const { data } = yield call(Apis.fetchInvestmentUpdatedDocs);
        yield put(InvestmentsActions.setUpdatedDocuments(data || []));
    } catch (err) {
        yield put(InvestmentsActions.setUpdatedDocuments([]));
    }
};

const fetchInvestmentExecutedAgreements = function* fetchInvestmentExecutedAgreements() {
    try {
        const { data } = yield call(Apis.fetchInvestmentExecutedAgreements);
        yield put(InvestmentsActions.setInvestmentExecutedAgreements(data || []));
    } catch (err) {
        yield put(InvestmentsActions.setInvestmentExecutedAgreements([]));
    }
};

export default function* sagas() {
    yield takeLatest(InvestmentTypes.GET_INVESTMENTS_REQ, fetchInvestmentsReq);
    yield takeLatest(InvestmentTypes.FETCH_REPAYMENT_REQ, fetchRepaymentReq);
    yield takeLatest(InvestmentTypes.FETCH_INVESTMENT_DETAILS, fetchInvestmentDetailsReq);
    yield takeLatest(InvestmentTypes.FETCH_EXECUTED_AGREEMENTS, fetchExecutedAgreementsReq);
    yield takeLatest(InvestmentTypes.FETCH_UPDATED_OR_REPORTIES, fetchUpdatesReq);
    yield takeLatest(InvestmentTypes.FETCH_PERFORMANCES, fetchPerformancesReq);
    yield takeLatest(InvestmentTypes.FETCH_DISTRIBUTION, fetchDistributionReq);
    yield takeLatest(InvestmentTypes.FETCH_PPM, fetchPPMReq);
    yield takeLatest(InvestmentTypes.FETCH_REPORTING_OBLIGATION, fetchReportingObligationReq);
    yield takeLatest(InvestmentTypes.FETCH_CASHFLOW, fetchCashflowReq);
    yield takeLatest(InvestmentTypes.FETCH_GUARANTEES, fetchGuaranteesReq);
    yield takeLatest(InvestmentTypes.FETCH_SECURITIES, fetchSecuritiesReq);
    yield takeLatest(InvestmentTypes.FETCH_COVENANTS, fetchCovenantsReq);
    yield takeLatest(InvestmentTypes.FETCH_AGGREGATE, fetchAggregateReq);
    yield takeLatest(InvestmentTypes.FETCH_UPDATE_DOCUMENTS, fetchUpdatedDcoumentsReq);
    yield takeLatest(InvestmentTypes.FETCH_INVESTMENT_EXECUTED_AGREEMENTS, fetchInvestmentExecutedAgreements);
}
